import { render, staticRenderFns } from "./FirstFilter.vue?vue&type=template&id=3b8de634&scoped=true&"
import script from "./FirstFilter.vue?vue&type=script&lang=js&"
export * from "./FirstFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8de634",
  null
  
)

export default component.exports